export const FIRM = {
  name: "Jay Kular & Associates",
  type: "Practising Company Secretaries",
  proprietor: "Jay Kular",
  established: "April 2026",
  experience: "10+",
  title: "Founder & Principal Consultant",
  address: "104, Sanjay Complex, Rajput Para Main Road, Rajkot – 360001",
  phone: "+91 8460042325",
  whatsapp: "918460042325",
  email: "csjaykular@gmail.com",
  membership: "",
  linkedin: "#",
};

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/blogs", label: "Insights" },
  { to: "/clients", label: "Clients & Reviews" },
  { to: "/contact", label: "Contact" },
];
